export default "__VITE_ASSET__uWijjfDv__"